module.exports = __webpack_public_path__ + "img/rotate.d389bfdf.svg";